import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import {useComparisonInfoActions} from '../stores/selectors'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {FilesRoutePayload} from '../page-data/payloads/files'

export type UpdateWhitespacePreferenceMutationResponse = {
  ignoreWhitespace: boolean
}

export function useUpdateWhitespacePreferenceMutation() {
  const {
    pullRequest: {pathName: basePath},
  } = useRoutePayload<FilesRoutePayload>()
  const {updateWhitespace} = useComparisonInfoActions()

  return useMutation({
    mutationFn: async ({hideWhitespace}: {hideWhitespace: boolean}) => {
      const apiUrl = `${basePath}/page_data/${PageData.updateWhitespacePreference}`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          w: hideWhitespace ? 1 : 0,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: UpdateWhitespacePreferenceMutationResponse) => {
      updateWhitespace(data.ignoreWhitespace)
    },
  })
}
